import { render } from "./RecordHistory.vue?vue&type=template&id=883e7706"
import script from "./RecordHistory.vue?vue&type=script&lang=js"
export * from "./RecordHistory.vue?vue&type=script&lang=js"

import "./RecordHistory.vue?vue&type=style&index=0&id=883e7706&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__